import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useMenuItem } from 'react-aria';

import styles from './MenuItem.module.scss';

const MenuItem = ({ item, state }) => {
    const ref = useRef();
    const { menuItemProps, isFocused, isDisabled } = useMenuItem(
        {
            key: item?.key,
            ...item?.props
        },
        state,
        ref
    );

    return (
        <li
            ref={ref}
            {...menuItemProps}
            className={[
                styles.container,
                isFocused ? styles.focused : null,
                isDisabled ? styles.disabled : null,
                item?.props?.className
            ].join(' ')}
        >
            {item.rendered}
        </li>
    );
};

MenuItem.PrppTypes = {
    item: PropTypes.any,
    state: PropTypes.any
};

export default MenuItem;
